import moment from 'moment'
import weeksjosn from './../../pages/SeasonalPattern/FullYearSeasonChartWeeks.json'
import offweeksjosn from './../../pages/SeasonalPattern/OffSeasonChartWeeks.json'
import { CurrentEpiWeek } from './../../pages/SeasonalPattern/transformDataForGrid'
import getNumberFromString from './../../utils/getNumberFromString'
import getStringFromNumberString from './../../utils/getStringFromNumberString'

const toolTipFormatter = (ordinate, xAxisLable) => {
  let toolTipHTML = ''
  let epiweek = ordinate.x
  if (xAxisLable === 'epiWeek') {
    toolTipHTML = `<div style="border:1px solid #CBCCCD;background-color:white;padding-top:16px;">`
    toolTipHTML += `<h4 style="color: #000; font-size:14px; padding-left: 10px; ">
        Epiweek ${ordinate.x}</h4>`
  } else {
    const date = moment(ordinate.x).format('MMM D, YYYY')
    toolTipHTML = `<h4 style="background-color: white; color: #black; padding: 10px; ">
        ${date} / Epiweek ${epiweek}</h4>`
  }
  const date = moment(ordinate.x).format('MMM D, YYYY')
  toolTipHTML += `<h4 style=" color: #000; font-size:12px; padding: 10px; ">
        ${date} : ${ordinate.y}</h4>`
  toolTipHTML += `</div>`

  return toolTipHTML
}
const toolTipFormatterDateWeek = (ordinate, data) => {
  const currentWeekMinus3Weeks = new Date(CurrentEpiWeek())
  currentWeekMinus3Weeks.setDate(currentWeekMinus3Weeks.getDate() - 21)
  let toolTipHTML = ''
  let epiweek = ordinate.x
  toolTipHTML = `<div style="background-color: #FFFFFF;color:#4B4D4F;  padding: 16px;border: 1px  #CBCCCD;
  border-radius: 4px; ">
   <span style="font-family: 'Optum Sans', sans-serif;
   font-style: normal;
   font-weight: 700;
   font-size: 14px;
   line-height: 18px;">
     Epiweek ${epiweek}</span>`
     var showprediction=true
  ordinate.points.forEach((point) => {
    showprediction=(point.series.name.toLocaleString().toLowerCase()==="prediction intervals"?true:false)
    let weekindex = 0
    let legendSymbol = ''
    if(point.series.data.length<=20)
    { offweeksjosn.forEach((epiweek, i) => {
      if (point.x === weeksjosn[i]) {
        weekindex = i
      }
    })}
    else( weeksjosn.forEach((epiweek, i) => {
      if (point.x === weeksjosn[i]) {
        weekindex = i
      }
    }))
   
    
    let isActual=
      (moment(currentWeekMinus3Weeks).format('MMM DD,YYYY') !==
      moment(point.series.data[weekindex].week_ending).format('MMM DD,YYYY'))
    if (point.series.legendSymbol !== undefined) {
      let series = point.series
      legendSymbol =
        "<svg width='16' height='16'>" +
        series.legendSymbol.element.outerHTML +
        point.series.legendSymbol.element.previousElementSibling.outerHTML +
        '</svg>'
    }
    if ('high' in point.point && isActual) {
      toolTipHTML += `<h6 style="font-family: 'Optum Sans', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;"><span style="padding-right:8px;">${legendSymbol}</span>${moment(
        point.series.data[weekindex].week_ending
      ).format('MMM DD,YYYY')}: <b> ${point.point.low.toLocaleString(
        undefined,
        {
          minimumFractionDigits: 0,
        }
      )} - ${point.point.high.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      })}</b></h6></div>`
    } else if (
      point.series.name.toLocaleString().toLowerCase() !== 'baseline' &&
      isActual
    ) {
      toolTipHTML += `<h6 style="font-family: 'Optum Sans', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;"><span style="padding-right:8px;">${legendSymbol}</span>${moment(
        point.series.data[weekindex].week_ending
      ).format('MMM DD,YYYY')}: <b>${point.y.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      })}</b></h6>`
    } else if (
      point.series.name.toLocaleString().toLowerCase() !== 'forecast' &&
      point.series.name.toLocaleString().toLowerCase() !==
        'prediction intervals'
    ) {
      toolTipHTML += `<h6 style="font-family: 'Optum Sans', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;"><span style="padding-right:8px;">${legendSymbol}</span>
      ${
        point.series.name.toLocaleString().toLowerCase() === 'baseline'
          ? 'Baseline'
          : moment(point.series.data[weekindex].week_ending).format(
              'MMM DD,YYYY'
            )
      }: <b>${point.y.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      })}</b></h6>`
    }
  })

  return toolTipHTML
}
const toolTipFormatterDateWeekNew = (ordinate, data) => {
  const currentWeekMinus3Weeks = new Date(CurrentEpiWeek())
  currentWeekMinus3Weeks.setDate(currentWeekMinus3Weeks.getDate() - 21)
  let toolTipHTML = ''
  let epiweek = ordinate.x
  toolTipHTML = `<div style="background-color: #FFFFFF;color:#4B4D4F;  padding: 16px;border: 1px  #CBCCCD;
  border-radius: 4px; ">
   <span style="font-family: 'Optum Sans', sans-serif;
   font-style: normal;
   font-weight: 700;
   font-size: 14px;
   line-height: 18px;">
     Epiweek ${epiweek}</span>`
     var showprediction=true
  ordinate.points.forEach((point) => {
    showprediction=(point.series.name.toLocaleString().toLowerCase()==="prediction intervals"?true:false)
    let weekindex = 0
    let legendSymbol = ''
    if(point.series.data.length<=20)
    { offweeksjosn.forEach((epiweek, i) => {
      if (point.x === weeksjosn[i]) {
        weekindex = i
      }
    })}
    else( weeksjosn.forEach((epiweek, i) => {
      if (point.x === weeksjosn[i]) {
        weekindex = i
      }
    }))
    let isActual=true
  
    if (point.series.legendSymbol !== undefined) {
      let series = point.series
      legendSymbol =
        "<svg width='16' height='16'>" +
        series.legendSymbol.element.outerHTML +
        point.series.legendSymbol.element.previousElementSibling.outerHTML +
        '</svg>'
    }
    if ('high' in point.point && isActual) {
      toolTipHTML += `<h6 style="font-family: 'Optum Sans', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;"><span style="padding-right:8px;">${legendSymbol}</span>${moment(
        point.series.data[weekindex].week_ending
      ).format('MMM DD,YYYY')}: <b> ${point.point.low.toLocaleString(
        undefined,
        {
          minimumFractionDigits: 0,
        }
      )} - ${point.point.high.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      })}</b></h6></div>`
    } else if (
      point.series.name.toLocaleString().toLowerCase() !== 'baseline' &&
      isActual
    ) {
      toolTipHTML += `<h6 style="font-family: 'Optum Sans', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;"><span style="padding-right:8px;">${legendSymbol}</span>${moment(
        point.series.data[weekindex].week_ending
      ).format('MMM DD,YYYY')}: <b>${point.y.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      })}</b></h6>`
    } else if (
      point.series.name.toLocaleString().toLowerCase() !== 'forecast' &&
      point.series.name.toLocaleString().toLowerCase() !==
        'prediction intervals'
    ) {
      toolTipHTML += `<h6 style="font-family: 'Optum Sans', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;"><span style="padding-right:8px;">${legendSymbol}</span>
      ${
        point.series.name.toLocaleString().toLowerCase() === 'baseline'
          ? 'Baseline'
          : moment(point.series.data[weekindex].week_ending).format(
              'MMM DD,YYYY'
            )
      }: <b>${point.y.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      })}</b></h6>`
    }
  })

  return toolTipHTML
}
const toolTipFormatterDate = (ordinate) => {
  let toolTipHTML = ''
  const date = moment.utc(ordinate.x).format('MMM DD, YYYY')

  toolTipHTML+= `<div style="background-color: #FFFFFF;color:4B4D4F;padding: 12px 12px;border: 1px  solid #CBCCCD;
          border-radius: 4px; font-family: 'Optum Sans', sans-serif;
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          ">
          <div>${date}</div>`
          // <div style="color:#002677;padding-top:10px">${'nat'}</div>`
          let legendSymbol
    ordinate.points.forEach((point) => {  
      if (point.series.legendSymbol !== undefined) {
        let series = point.series
        legendSymbol =
          "<svg width='16' height='16'>" +
          series.legendSymbol.element.outerHTML +
          point.series.legendSymbol.element.previousElementSibling.outerHTML +
          '</svg>'
      } 
         
      toolTipHTML+=`<div style='padding-top:10px'><span style='padding-right:10px'>${legendSymbol}</span><span >${getStringFromNumberString(point.series.name)}<sub>${getNumberFromString(point.series.name)}</sub> :</span> <span style='padding-left:10px;font-weight:400'>${point.y}</span></div>`
    })
   
    toolTipHTML+=`</div>          `

  // toolTipHTML = `<div style="border:1px solid #CBCCCD;background-color:white;padding-top:16px;">`
  
  // const date = moment(ordinate.x).format('MMM D, YYYY')
  // toolTipHTML = `<h4 style="background-color: white; color: #black; padding: 10px; ">
  //        ${date} </h4>`
 
  // toolTipHTML += `<h4 style=" color: #000; font-size:12px; padding: 10px; ">
  //       Point : ${ordinate.y}</h4>`
  // toolTipHTML += `</div>`

  return toolTipHTML
}
const toolTipFormatterDateAllergies = (ordinate) => {
  let toolTipHTML = ''
  const date = moment.utc(ordinate.x).format('MMM DD, YYYY')

  toolTipHTML+= `<div style="background-color: #FFFFFF;color:4B4D4F;padding: 12px 12px;border: 1px  solid #CBCCCD;
          border-radius: 4px; font-family: 'Optum Sans', sans-serif;
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          ">
          <div>${date}</div>
          <div style="color:#002677;padding-top:5px">${'geo_id'}</div>`
          let legendSymbol
    ordinate.points.forEach((point) => {  
      if (point.series.legendSymbol !== undefined) {
        let series = point.series
        legendSymbol =
          "<svg width='16' height='16'>" +
          series.legendSymbol.element.outerHTML +
          point.series.legendSymbol.element.previousElementSibling.outerHTML +
          '</svg>'
      } 
         
      toolTipHTML+=`<div style='padding-top:5px'><span >${point.series.name}:</span> <span style='padding-left:10px;font-weight:400'>${point.y}</span></div>`
    })
   
    toolTipHTML+=`</div>          `
  return toolTipHTML
}
function epiweekToolTip() {
  return toolTipFormatter(this, 'epiWeek')
}

function dateToolTip() {
  return toolTipFormatterDate(this)
}
function dateToolTipAllergies() {
  return toolTipFormatterDateAllergies(this)
}
function dateWeekToolTip() {
  return toolTipFormatterDateWeek(this)
}
function dateWeekToolTipNew() {
  return toolTipFormatterDateWeekNew(this)
}

export { epiweekToolTip, dateToolTip,dateToolTipAllergies, dateWeekToolTip,dateWeekToolTipNew }
